import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useI18nContext } from '@/i18n/i18n-react';
import { mobileLayer } from '@/lib/mobile-layer';

/**
 * Discard confirmation for `useDiscardGuard` (PUSH-05 AC 7). Closing it any
 * other way (Esc, overlay) keeps the user editing.
 */
export function DiscardChangesDialog({
  open,
  onDiscard,
  onKeepEditing,
}: {
  open: boolean;
  onDiscard(): void;
  onKeepEditing(): void;
}) {
  const { LL } = useI18nContext();

  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onKeepEditing();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {LL.campaignComposer.discard.title()}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {LL.campaignComposer.discard.description()}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className={mobileLayer.touch}>
            {LL.campaignComposer.discard.keepEditing()}
          </AlertDialogCancel>
          <Button
            type="button"
            variant="destructive"
            className={mobileLayer.touch}
            onClick={onDiscard}
          >
            {LL.campaignComposer.discard.confirm()}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
